import { useContext } from "react";
import { VehicleContext } from "../providers";

const useVehicle = () => {
  const vehicleContext = useContext(VehicleContext);

  if (!vehicleContext) {
    throw new Error("useVehicle must be used within an VehicleProvider");
  }
  return vehicleContext;
};

export default useVehicle;
